import I18n from 'app/i18n';
import {OtherItemInterface} from 'app/store/OtherItemStore';

export const otherItemDescription = (artifact: OtherItemInterface): string => {
    const {content_langs, description} = artifact;
    return content_langs && content_langs[I18n.locale] || description;
};
